import React from 'react'

const sectionStyle = {
  border: '1px solid #e4eaf2',
  borderRadius: 10,
  overflow: 'hidden',
  height: '100%',
}

const sectionHdStyle = {
  padding: '10px 14px',
  background: '#f5f7fa',
  borderBottom: '1px solid #e4eaf2',
  fontSize: 12,
  fontWeight: 700,
  color: '#4a6080',
  textTransform: 'uppercase',
  letterSpacing: 0.5,
  display: 'flex',
  alignItems: 'center',
  gap: 8,
}

const thStyle = {
  padding: '7px 12px',
  fontSize: 11,
  fontWeight: 700,
  color: '#6b7c93',
  textTransform: 'uppercase',
  letterSpacing: 0.4,
  background: '#fafbfc',
  borderBottom: '1px solid #e4eaf2',
  whiteSpace: 'nowrap',
}

const tdStyle = {
  padding: '7px 12px',
  fontSize: 13,
  color: '#1a2e4a',
  borderBottom: '1px solid #f0f3f7',
  whiteSpace: 'nowrap',
}

const tdTotalStyle = {
  ...tdStyle,
  fontWeight: 700,
  background: '#f5f7fa',
  borderBottom: 'none',
}

const tdAccentStyle = {
  ...tdStyle,
  color: '#27ae60',
  fontWeight: 600,
}

const tdAccentTotalStyle = {
  ...tdTotalStyle,
  color: '#27ae60',
}

class MoneyTable extends React.Component {
  render() {
    const { Bills_in_box, Cash_in_box, Cash_in_coiner } = this.props.machine

    const billsTotal     = Bills_in_box.five * 5 + Bills_in_box.ten * 10 + Bills_in_box.twenty * 20
    const cashTotal      = Cash_in_box.fifty * 0.5 + Cash_in_box.one + Cash_in_box.two * 2
    const coinerTotal    = Cash_in_coiner.fifty * 0.5 + Cash_in_coiner.one + Cash_in_coiner.two * 2

    return (
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>

        {/* Billetes */}
        <div style={sectionStyle}>
          <div style={sectionHdStyle}>
            <i className="fas fa-money-bill-wave"></i> Caja de billetes
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={thStyle}>Billete</th>
                <th style={thStyle}>Cantidad</th>
                <th style={thStyle}>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={tdStyle}>5 €</td>
                <td style={tdStyle}>{Bills_in_box.five}</td>
                <td style={tdAccentStyle}>{(Bills_in_box.five * 5).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdStyle}>10 €</td>
                <td style={tdStyle}>{Bills_in_box.ten}</td>
                <td style={tdAccentStyle}>{(Bills_in_box.ten * 10).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdStyle}>20 €</td>
                <td style={tdStyle}>{Bills_in_box.twenty}</td>
                <td style={tdAccentStyle}>{(Bills_in_box.twenty * 20).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdTotalStyle}>Total</td>
                <td style={tdTotalStyle}>{Bills_in_box.five + Bills_in_box.ten + Bills_in_box.twenty}</td>
                <td style={tdAccentTotalStyle}>{billsTotal.toFixed(2)} €</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Monedas */}
        <div style={sectionStyle}>
          <div style={sectionHdStyle}>
            <i className="fas fa-coins"></i> Caja de monedas
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={thStyle}>Moneda</th>
                <th style={thStyle}>Cantidad</th>
                <th style={thStyle}>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={tdStyle}>0.50 €</td>
                <td style={tdStyle}>{Cash_in_box.fifty}</td>
                <td style={tdAccentStyle}>{(Cash_in_box.fifty * 0.5).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdStyle}>1 €</td>
                <td style={tdStyle}>{Cash_in_box.one}</td>
                <td style={tdAccentStyle}>{(Cash_in_box.one).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdStyle}>2 €</td>
                <td style={tdStyle}>{Cash_in_box.two}</td>
                <td style={tdAccentStyle}>{(Cash_in_box.two * 2).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdStyle}>Token</td>
                <td style={tdStyle}>{Cash_in_box.token}</td>
                <td style={tdStyle}>—</td>
              </tr>
              <tr>
                <td style={tdTotalStyle}>Total</td>
                <td style={tdTotalStyle}>{Cash_in_box.fifty + Cash_in_box.one + Cash_in_box.two + Cash_in_box.token}</td>
                <td style={tdAccentTotalStyle}>{cashTotal.toFixed(2)} €</td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Tubos */}
        <div style={sectionStyle}>
          <div style={sectionHdStyle}>
            <i className="fas fa-sync-alt"></i> Tubos de cambio
          </div>
          <table style={{ width: '100%', borderCollapse: 'collapse' }}>
            <thead>
              <tr>
                <th style={thStyle}>Moneda</th>
                <th style={thStyle}>Cantidad</th>
                <th style={thStyle}>Valor</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td style={tdStyle}>0.50 €</td>
                <td style={tdStyle}>{Cash_in_coiner.fifty}</td>
                <td style={tdAccentStyle}>{(Cash_in_coiner.fifty * 0.5).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdStyle}>1 €</td>
                <td style={tdStyle}>{Cash_in_coiner.one}</td>
                <td style={tdAccentStyle}>{(Cash_in_coiner.one).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdStyle}>2 €</td>
                <td style={tdStyle}>{Cash_in_coiner.two}</td>
                <td style={tdAccentStyle}>{(Cash_in_coiner.two * 2).toFixed(2)} €</td>
              </tr>
              <tr>
                <td style={tdTotalStyle}>Total</td>
                <td style={tdTotalStyle}>{Cash_in_coiner.fifty + Cash_in_coiner.one + Cash_in_coiner.two}</td>
                <td style={tdAccentTotalStyle}>{coinerTotal.toFixed(2)} €</td>
              </tr>
            </tbody>
          </table>
        </div>

      </div>
    )
  }
}

export default MoneyTable


